var dd = require('react-dd');
var FormInputMixin = require('../FormInputMixin');

var component = dd.createClass({
	mixins: [FormInputMixin],
	__onChange: function(e){
		this._input_newValue(e.target.files);
	},
	render: function(){
		var field = this.props.field;
		var value = this.props.value;

		if(typeof FileList === 'undefined'){
			return dd.p({className: 'form-control-static text-danger'},
				'Your browser is outdated and will not work with this file upload.'
			);
		}
		if(field.read_only){
			return dd.p({className: 'form-control-static'},
				value
			);
		}
		return dd.input({
			type: 'file',
			name: this.props.field_path,
			className: 'form-control',
			style: {border: 0, boxShadow: 'none', paddingLeft: 0, paddingRight: 0},
			onChange: this.__onChange,
			multiple: field.multiple === true ? true : false
		});
	}
});

module.exports = {
	component: component,
	validate: function(value){
		return ((value instanceof FileList) && value.length > 0) || 'You must select a file to upload';
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/forms/inputs/File.js
// module id = 199
// module chunks = 0 1 2 3 4